import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';

import * as loginActions from 'modules/login';
import * as userActions from 'modules/user';
import * as loginLib from 'libs/loginLib';

import * as commonVar from 'libs/commonVar';
import * as common from 'libs/commonFunc';

import { clearReduxStore } from 'containers/InitialStore';
import { CtFirstLogin } from 'containers';
import { Login, NoActive } from 'components';
import { AlreadyLoginPage } from 'pages';

import { changeSaas, changeGS, changeEdu, changeDeclare, changeJapan, changePhishing } from 'libs/commonVar';

import styled from 'styled-components';

const ScSection = styled.section`
  width: 100%;
  height: 100%;
  display: inherit;
`;

/* 로그인 컴포넌트 */
class CtLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      // 0: x, 1: 메일 재전송 성공, 2: 메일 전송 실패
      isReSendMail: 0,
      alreadyLogin: 0,
      isFirstLogin: false,
      saveCheck: !!Number(localStorage.getItem('saveCheck')) || 0,
      saveEmail: localStorage.getItem('saveEmail') || ''
    };

    this.signIn = this.signIn.bind(this);
    this.noActiveLogin = this.noActiveLogin.bind(this);
    this.reSendMail = this.reSendMail.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  componentWillMount() {
    // 이미 로그인된 상태인지 확인하여 render 시 안내
    if (this.props.isAuth === 1) {
      this.setState({ alreadyLogin: 1 });
    } else {
      // store 초기화
      const { Dispatch } = this.props;
      clearReduxStore(Dispatch, 'all');
    }
  }

  componentDidMount() {
    const { LoginActions } = this.props;
    const name = 'userEmail';
    const value = localStorage.getItem('saveEmail');
    LoginActions.changeInput({
      name,
      value
    });

    // 로그인 실패 횟수가 5회가 넘어가면 recaptcha 실행
    if (Number(localStorage.getItem('loginCnt')) > 5) {
      LoginActions.activeRecaptcha();
      // 로그인 5회 실패시 남은시간 실시간 표현
      this.intervalUpdate = setInterval(() => this.forceUpdate(), 1000);
    }
    this.setState({ isFirstLogin: false });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.isAuth === 0 ||
      nextProps.isAuth === 0 ||
      this.state.alreadyLogin !== nextState.alreadyLogin ||
      this.props.isAuth !== nextProps.isAuth ||
      this.props.loginResult !== nextProps.loginResult ||
      this.props.pending !== nextProps.pending ||
      this.props.visibleCaptcha !== nextProps.visibleCaptcha ||
      this.props.visibleNoActive !== nextProps.visibleNoActive ||
      this.state.isFirstLogin !== nextState.isFirstLogin
    ) {
      return true;
    }
    return false;
  }

  // 로그인 5회 실패시 남은시간 실시간 표현 인터벌 해제
  componentWillUnmount() {
    clearInterval(this.intervalUpdate);
  }

  // 비활성화 계정 로그인 처리
  noActiveLogin = async () => {
    this.setState({ isLoading: true });
    const { loginResult, UserActions, userData, sessionTimeout } = this.props;

    try {
      if (Number(loginResult) === 32) {
        await UserActions.setUser({ user: userData, sessionTimeout });
      }

      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 비활성화 계정 이메일 재전송
  reSendMail = async () => {
    this.setState({ isLoading: true });

    try {
      const { form } = this.props;
      const respObj = await loginLib.reSendRegisterEmail({ userEmail: form.get('userEmail') });
      if (respObj && respObj.status && respObj.status === 200) {
        if (respObj.data && Array.isArray(respObj.data.list)) {
          // 메일 재전송 성공
          this.setState({ isReSendMail: 1 });
        } else {
          // 메일 재전송 실패
          this.setState({ isReSendMail: 2 });
        }
      } else {
        // 응답 오류
      }

      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 로그인 처리
  signIn = async () => {
    const { LoginActions, UserActions, form } = this.props;
    const { userEmail, userPasswd } = form.toJS();

    if (!!this.state.isLoading) {
      return false;
    }
    this.setState({ isLoading: true });
    try {
      // 로그인 횟수 처리
      if (isNaN(localStorage.getItem('loginCnt'))) {
        localStorage.setItem('loginCnt', 1);
      } else {
        localStorage.setItem('loginCnt', Number(localStorage.getItem('loginCnt')) + 1);
      }

      // 이메일 저장 체크시 쿠키에 이메일 저장
      if (this.state.saveCheck) {
        localStorage.setItem('saveCheck', 1);
        localStorage.setItem('saveEmail', form.get('userEmail'));
      } else {
        localStorage.setItem('saveCheck', 0);
        localStorage.setItem('saveEmail', '');
      }

      const respObj = await LoginActions.postLogin({
        userEmail: userEmail.toLowerCase(),
        userPasswd
      });

      // 구축형
      if (respObj && respObj.status && respObj.status === 200 && respObj.data && respObj.data.list) {
        changeSaas(respObj.data.list.isSaas);
        changeGS(respObj.data.list.isGs);
        changeJapan(respObj.data.list.isJapan);
        changeEdu(respObj.data.list.isEdu);
        changeDeclare(respObj.data.list.isDeclare);
      }

      const { userData, loginResult, serviceNo, sessionTimeout } = this.props;

      /* -- 로그인 성공 -- */
      if (loginResult === 1) {
        userData['serviceNo'] = serviceNo;
        await UserActions.setUser({ user: userData, sessionTimeout });

        if (commonVar.isGs === 1) {
          sessionStorage.setItem('curUser', userData.userEmail);
        }

        localStorage.removeItem('loginAdmin');
        localStorage.setItem('loginUser', userData.userEmail);
        sessionStorage.setItem('accessTime', common.nowEpoch());

        // 로그인 횟수 초기화
        localStorage.setItem('loginCnt', 0);

        // 언어 설정
        if (localStorage.getItem('language') !== userData.lang) {
          localStorage.setItem('language', userData.lang);
          window.location.reload();
        }

        /* -- 로그인 서버 에러 -- */
      } else if (loginResult === 2) {
        //
        /* -- ID or 비밀번호 불일치 -- */
      } else if (loginResult === 4) {
        //
        /* -- 비밀번호 5회 이상 실패 -- */
      } else if (loginResult === 8) {
        // google reCAPTCHA
        // LoginActions.activeRecaptcha();
        /* -- 6개월 이상 비밀번호 미변경 -- */
      } else if (loginResult === 16) {
        // 비밀번호 찾기 페이지로 이동
        // return <Redirect to={{ pathname: '/login/passwdReset' }} />;
        return window.location.replace('/login/passwdReset');
        /* -- 비활성화 계정 - 로그인가능 -- */
      } else if (loginResult === 32) {
        // 비활성화 모달 오픈
        LoginActions.viewNoActive(true);

        if (commonVar.isGs === 1) {
          sessionStorage.setItem('curUser', userData.userEmail);
        }
        localStorage.removeItem('loginAdmin');
        localStorage.setItem('loginUser', userData.userEmail);
        sessionStorage.setItem('accessTime', common.nowEpoch());

        /* -- 비활성화 계정 - 기간 만료 -- */
      } else if (loginResult === 64) {
        LoginActions.viewNoActive(true);

        /* 잠김 계정 */
      } else if (loginResult === 128) {
        //
      } else if (loginResult === 256) {
        /* -- 관리자가 생성한 계정 최초 로그인시 비밀번호 수정 화면 -- */
        this.setState({ isFirstLogin: true });
      } else {
        //
      }

      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  // input에 값 입력 처리
  handleChange = e => {
    const { LoginActions, loginResult } = this.props;
    const { name, value } = e.target;

    LoginActions.changeInput({
      name,
      value
    });

    // 실패 메세지 지움
    if (loginResult > 1) {
      LoginActions.initLoginResult();
    }
  };

  handleKeyPress = e => {
    const { name, value } = e.target;

    if (e.key === 'Enter') {
      this.signIn();
    }
  };

  handleCheckbox = e => {
    this.setState({ saveCheck: Number(!this.state.saveCheck) });
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { signIn, noActiveLogin, reSendMail, handleChange, handleKeyPress, handleCheckbox } = this;
    const { pending, visibleCaptcha, visibleNoActive, form, login, loginResult, loginMessage, isAuth } = this.props;

    if (isAuth === 1) {
      // 이미 로그인 된 상태로 접속
      if (this.state.alreadyLogin) {
        return <AlreadyLoginPage accessLevel={1} />;
      }

      // 로그인 페이지에서 로그인 성공 처리된 것
      return (
        <Redirect
          to={{
            // pathname: '/main/exam/pi'
            pathname: '/main/dashboard'
          }}
        />
      );
    }

    // 로그인 실패 횟수 초과 경우 5분의 잠금
    let loginMessageText = String(loginMessage);
    if (loginResult === 8) {
      const remainTime = 300 - (common.nowEpoch().toFixed() - loginMessage.split(',')[1]);
      loginMessageText =
        loginMessage.split(',')[0] +
        ' (' +
        defineMessages(formatMessage({ id: 'CtLogin_1', defaultMessage: '남은 시간' })) +
        ': ' +
        (parseInt(remainTime / 60) > 0
          ? parseInt(remainTime / 60) + defineMessages(formatMessage({ id: 'CtLogin_2', defaultMessage: '분' })) + ' '
          : '') +
        parseInt(remainTime % 60) +
        defineMessages(formatMessage({ id: 'CtLogin_3', defaultMessage: '초' })) +
        ')';
    }

    let ViewComponent = (
      <Login
        isLoading={this.state.isLoading}
        signIn={signIn}
        handleChange={handleChange}
        handleKeyPress={handleKeyPress}
        handleCheckbox={handleCheckbox}
        visibleCaptcha={visibleCaptcha}
        login={login}
        loginResult={loginResult}
        loginMessage={loginMessageText}
        pending={pending}
        saveEmail={this.state.saveEmail}
        saveCheck={Number(this.state.saveCheck)}
      />
    );

    // 비활성화 계정
    if (!!visibleNoActive) {
      ViewComponent = (
        <NoActive
          isLoading={this.state.isLoading}
          userEmail={form.get('userEmail')}
          loginResult={loginResult}
          loginMessage={String(loginMessage)}
          noActiveLogin={noActiveLogin}
          reSendMail={reSendMail}
          isReSendMail={this.state.isReSendMail}
        />
      );
      // 관리자가 등록한 사용자 최초 로그인시 처리
    } else if (!!this.state.isFirstLogin) {
      ViewComponent = (
        <div className="admin-login">
          <CtFirstLogin userEmail={form.get('userEmail')} />
        </div>
      );
    }

    return <ScSection>{ViewComponent}</ScSection>;
  }
}

const mapStateToProps = state => ({
  login: state.login.get('login'),
  loginResult: state.login.getIn(['login', 'loginResult']),
  loginMessage: state.login.getIn(['login', 'loginMessage']),
  userData: state.login.getIn(['login', 'userData']),
  sessionTimeout: state.login.getIn(['login', 'sessionTimeout']),
  serviceNo: state.login.getIn(['login', 'serviceNo']),
  form: state.login.get('form'),
  visibleCaptcha: state.login.getIn(['visible', 'captcha']),
  visibleNoActive: state.login.getIn(['visible', 'noActive']),
  isAuth: state.user.get('isAuth'),
  pending: state.pender.pending['login/POST_LOGIN']
});

const mapDispatchToProps = dispatch => ({
  LoginActions: bindActionCreators(loginActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtLogin));



// WEBPACK FOOTER //
// ./src/script/containers/login/CtLogin.js